import * as React from 'react';

const FacebookIcon = (props) => (
    <svg width={30} height={30} fill="none" {...props}>
        <circle cx={15} cy={15} r={15} fill="#3A62A8" />
        <mask
            id="a"
            width={30}
            height={30}
            x={0}
            y={0}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: 'luminance'
            }}
        >
            <circle cx={15} cy={15} r={15} fill="#fff" />
        </mask>
        <path
            fill="#fff"
            fillRule="evenodd"
            d="M15.896 23.864h-3.325v-7.842h-1.662V13.32h1.662v-1.623c0-2.204.938-3.515 3.604-3.515h2.219v2.703h-1.387c-1.038 0-1.107.377-1.107 1.082l-.004 1.353h2.513l-.294 2.702h-2.219v7.842Z"
            clipRule="evenodd"
        />
    </svg>
);

export default FacebookIcon;
